import { render } from "./BulkUploadLocationsDialog.vue?vue&type=template&id=b577f8ca&ts=true"
import script from "./BulkUploadLocationsDialog.vue?vue&type=script&lang=ts"
export * from "./BulkUploadLocationsDialog.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__